import { createReducer } from '@reduxjs/toolkit';
import * as actions from '@/store/actions';

const initialState = false;

export default createReducer(initialState, {
	[actions.updateRetrievingProjectsFailed.type]: (_, { payload }): boolean => payload,
});
